import React from "react";
import { Modal, Button } from "react-bootstrap";
import styled from "styled-components";
import { Check} from "react-bootstrap-icons";

import ImpersonationModal from "./ImpersonationModal";

const ImpersonationModalWithState = ({
  userId,
  onClose,
  isSubmitting = false,
  formState,
  onSubmit,
  ...props
}) => {
  return (
    <Modal centered show keyboard="false" onHide={onClose}>
      <Container>
        <ImpersonationModal formState={formState} {...props}/>
        <br />
        <div className="d-md-flex justify-content-md-end">
            <Button
                className="mr-2"
                variant="secondary"
                onClick={onClose}
                disabled={isSubmitting}
            >
                Close
            </Button>
            <Button
                variant="success"
                onClick={()=>onSubmit(userId)}
                disabled={isSubmitting}
            >
                <Check />
                Add
            </Button>
        </div>
      </Container>
    </Modal>
  );
};

const Container = styled.div(
  ({ theme }) => `
    padding: ${theme.spacing}rem;
`,
);

export default ImpersonationModalWithState;
